"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularSpinner = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const { circle: Circle, root: Root, svg: Svg } = styles_1.styles;
const CircularSpinner = ({ size = 24, variant = "default", ...props }) => {
    return (react_1.default.createElement(Root, Object.assign({ size: size, variant: variant }, props),
        react_1.default.createElement(Svg, { viewBox: "22 22 44 44" },
            react_1.default.createElement(Circle, { cx: 44, cy: 44, fill: "none", r: 20.2, strokeWidth: 3.6 }))));
};
exports.CircularSpinner = CircularSpinner;
